import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Shuffle, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle } from "@/components/ui/dialog";

export const RandomTagDialog = ({ open, onClose, eventId, approvedCount, onDone }) => {
  const [rows, setRows] = useState([{ tag: "", count: "" }]);
  const [busy, setBusy] = useState(false);
  const total = rows.reduce((a, r) => a + (Number(r.count) || 0), 0);
  const upd = (i, p) => setRows(rows.map((r, j) => (j === i ? { ...r, ...p } : r)));

  const apply = async () => {
    const groups = rows.filter((r) => r.tag.trim() && Number(r.count) > 0).map((r) => ({ tag: r.tag.trim(), count: Number(r.count) }));
    if (!groups.length) { toast.error("Tag naam aur kitne pass, dono daalein"); return; }
    if (total > approvedCount) { toast.error(`Total ${total}, lekin approved sirf ${approvedCount} hain`); return; }
    if (!window.confirm("Is event ke saare purane tag hat jayenge aur naye random lagenge. Continue?")) { return; }
    setBusy(true);
    try {
      const r = await api.post(`/events/${eventId}/random-tags`, { groups });
      toast.success(`Random tag lag gaye: ${r.data.applied.map((a) => `${a.tag} (${a.count})`).join(", ")}`);
      onDone();
      onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || "Random tag nahi lage"); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="random-tag-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-1.5"><Shuffle className="h-4 w-4 text-amber-600" /> Random Tag</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground -mt-2">Tag category banayein aur batayein kitne pass par lagana hai. Sirf <b>approved</b> candidates me se random chune jayenge. Purane saare tag hat jayenge.</p>
        <div className="space-y-2 max-h-[50vh] overflow-y-auto">
          {rows.map((r, i) => (
            <div key={i} className="flex gap-2 items-center">
              <Input value={r.tag} onChange={(e) => upd(i, { tag: e.target.value })} placeholder="Tag e.g. VIP" maxLength={30} data-testid={`rtag-name-${i}`} />
              <Input type="number" min={1} value={r.count} onChange={(e) => upd(i, { count: e.target.value })} placeholder="Kitne pass" className="w-28" data-testid={`rtag-count-${i}`} />
              {rows.length > 1 && <Button variant="ghost" size="icon" onClick={() => setRows(rows.filter((_, j) => j !== i))} data-testid={`rtag-remove-${i}`}><X className="h-4 w-4" /></Button>}
            </div>
          ))}
        </div>
        <Button variant="outline" size="sm" className="gap-1 w-fit" onClick={() => setRows([...rows, { tag: "", count: "" }])} data-testid="rtag-add-btn"><Plus className="h-3.5 w-3.5" /> Add Tag Category</Button>
        <p className={`text-xs font-semibold ${total > approvedCount ? "text-red-600" : "text-slate-600"}`} data-testid="rtag-summary">Total: {total} / Approved: {approvedCount}</p>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="rtag-cancel-btn">Cancel</Button>
          <Button onClick={apply} disabled={busy} className="bg-amber-500 hover:bg-amber-600 text-white" data-testid="rtag-done-btn">{busy ? "Laga rahe..." : "Done"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
